module.exports = __webpack_public_path__ + "img/link2.8838263b.svg";